import {
  BackendMethod,
  remult,
  type AllowedForInstance,
  type BackendMethodOptions,
} from "remult";
import { type ClassMethodDecoratorContextStub } from "remult/src/server-action";

export interface HyperBackendMethodConfig<T>
  extends Omit<BackendMethodOptions<T>, "allowed"> {
  overrideSecurity?: boolean;
  allowed?: AllowedForInstance<T>;
}

export function HyperBackendMethod<T>(config: HyperBackendMethodConfig<T>) {
  const { overrideSecurity = false, allowed, ...rest } = config;

  return function (
    target: any,
    context: ClassMethodDecoratorContextStub<T> | string,
    descriptor?: PropertyDescriptor,
  ) {
    if (!descriptor) {
      descriptor = Object.getOwnPropertyDescriptor(target, context as string)!;
    }

    const originalMethod = descriptor.value;
    descriptor.value = function (...args: any[]) {
      const originalShouldOverrideSecurity =
        remult.context.shouldOverrideSecurity;
      remult.context.shouldOverrideSecurity = overrideSecurity;

      try {
        const result = originalMethod.apply(this, args);
        if (result instanceof Promise) {
          return result
            .catch((error) => {
              console.error(`Error in ${target.constructor.name}.${context}:`, error);
              throw error;
            })
            .finally(() => {
              remult.context.shouldOverrideSecurity =
                originalShouldOverrideSecurity;
            });
        } else {
          remult.context.shouldOverrideSecurity = originalShouldOverrideSecurity;
          return result;
        }
      } catch (error) {
        remult.context.shouldOverrideSecurity = originalShouldOverrideSecurity;
        console.error(`Error in ${target.constructor.name}.${context}:`, error);
        throw error;
      }
    };

    BackendMethod({ ...rest, allowed: allowed ?? true })(
      target,
      context,
      descriptor,
    );
  };
}
